import React, { Component } from "react";
// import App from "./app";

import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import reducers from "./../reducers/index";


import GeoT from './../GeoTrackDashboard'; 

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
// import lightGreen from '@material-ui/core/colors/lightGreen';
import teal from '@material-ui/core/colors/teal';
const theme = createMuiTheme({
  palette: {
    primary: teal,
    secondary: {
      main: '#ffeb3b',
    },
  },
});

const store = createStore(
  reducers,
  applyMiddleware(thunk)
);

const AppProvider = (
  <MuiThemeProvider theme={theme}> 
  <Provider store={store}>
    <GeoT />
  </Provider>
   </MuiThemeProvider>

)


class Main extends Component {
  render() {
    return (
      AppProvider
    )
  }
}

export default Main;